import { createActions } from 'redux-actions';

const { addVehicle, addVehicleSuccess, addVehicleError } = createActions(
  'ADD_VEHICLE',
  'ADD_VEHICLE_SUCCESS',
  'ADD_VEHICLE_ERROR'
);

export { addVehicle, addVehicleSuccess, addVehicleError };
